"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
var Session = /** @class */ (function () {
    function Session(cookies) {
        this.cookies = cookies;
        this.tracksCount = 1; // count of track events
        this.paramsSet = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'utm_id',
            'shortId',
            'gclid',
            'aff',
            'fbpx', // facebook pixel id
        ];
        console.log('Session init');
        this.session = this.start();
        this.initParams(); // get or cookies params
        this.initTracks();
    }
    Session.prototype.initParams = function () {
        var _this = this;
        console.log('Init params, lets search query params in url');
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        this.params = {};
        this.paramsSet.forEach(function (param) {
            var value = urlParams.get(param);
            if (value) {
                _this.params[param] = value;
                var days = ['fbpx'].includes(param) ? 1 : 365;
                _this.cookies.set(param, value, days);
                return;
            }
            value = _this.cookies.get(param);
            if (value) {
                _this.params[param] = value;
            }
        });
    };
    Session.prototype.initTracks = function () {
        var tracksCount = this.cookies.get('tracks-count');
        if (tracksCount) {
            this.tracksCount = parseInt(tracksCount);
        }
    };
    Session.prototype.getTracks = function () {
        return this.tracksCount;
    };
    Session.prototype.incrementTracks = function () {
        this.tracksCount += 1;
        this.cookies.set('tracks-count', this.tracksCount.toString(), 1);
    };
    Session.prototype.generateSessionId = function () {
        return Math.random().toString(36).substring(2, 15);
    };
    Session.prototype.start = function () {
        var sessionId = this.cookies.get(Session.SESSION_COOKIE);
        if (!sessionId) {
            var newSessionId = this.generateSessionId();
            this.cookies.set(Session.SESSION_COOKIE, newSessionId, 1);
            console.log('New session started:', newSessionId);
            return newSessionId;
        }
        else {
            console.log('Existing session:', sessionId);
            return sessionId;
        }
    };
    Session.prototype.get = function () {
        return this.session;
    };
    Session.prototype.getUtm = function () {
        return {
            source: this.params.utm_source,
            medium: this.params.utm_medium,
            campaign: this.params.utm_campaign,
            content: this.params.utm_content,
            term: this.params.utm_term,
            id: this.params.utm_id,
        };
    };
    Session.prototype.getGCLID = function () {
        return this.params.gclid || '';
    };
    Session.prototype.getShortId = function () {
        return this.params.shortId || '';
    };
    Session.prototype.getParntersWebId = function () {
        return this.params[Session.PP_WEBID] || '';
    };
    Session.prototype.getFacebookPixelId = function () {
        return this.params.fbpx;
    };
    Session.SESSION_COOKIE = 'session';
    Session.PP_WEBID = 'utm_content'; // webmasters id from partners network
    return Session;
}());
exports.Session = Session;
